/**
 * @file Button.component.js
 * Exports a button component.
 */
import React from 'react';
import bem from '../../_utils/bem';
/**
 * Component that renders a button with a click handler.
 */

var Button = function Button(_ref) {
  var onClick = _ref.onClick,
      children = _ref.children,
      _ref$block = _ref.block,
      block = _ref$block === void 0 ? 'button' : _ref$block,
      element = _ref.element,
      modifiers = _ref.modifiers;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: bem(block, element, modifiers),
    "aria-label": "button",
    onClick: onClick
  }, children);
};

Button.defaultProps = {
  children: null,
  onClick: function onClick() {}
};
export default Button;